import { render } from "./BeachIcon.vue?vue&type=template&id=5219b602"
import script from "./BeachIcon.vue?vue&type=script&lang=js"
export * from "./BeachIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__